export default __webpack_public_path__ + "static/media/bg-left.46260d7f.jpg";